type ExternalRegisterMarketHeaderContent = {
  name: string;
  icon: string;
};

type GetExternalRegisterMarketHeaderParams = {
  marketName: string;
  content?: ExternalRegisterMarketHeaderContent;
  marketIconUrl?: string;
};

export const getExternalRegisterMarketHeader = ({
  marketName,
  content,
  marketIconUrl,
}: GetExternalRegisterMarketHeaderParams): ExternalRegisterMarketHeaderContent => ({
  name: content?.name ?? marketName,
  icon: content?.icon ?? marketIconUrl ?? '',
});
